import { PropertyFilterQuery } from '@cloudscape-design/collection-hooks';
import { DateRangePickerProps } from '@cloudscape-design/components';

export type QueryTableEndpointName = string | readonly string[];

function endpointKeyParts(endpointName: QueryTableEndpointName): readonly string[] {
  return typeof endpointName === 'string' ? [endpointName] : endpointName;
}

export function queryTableMetaKey(endpointName: QueryTableEndpointName, now: Date) {
  return [...endpointKeyParts(endpointName), 'meta', now] as const;
}

export function queryTableItemsKey(
  endpointName: QueryTableEndpointName,
  query: PropertyFilterQuery,
  range: DateRangePickerProps.Value | null | undefined,
  pageSize: number,
  sortingField: string | undefined,
  sortDirection: 'asc' | 'desc' | undefined,
  page: number,
  now: Date,
) {
  return [
    ...endpointKeyParts(endpointName),
    query,
    range,
    pageSize,
    sortingField,
    sortDirection,
    page,
    now,
  ] as const;
}
